import React from "react";
import { Stack, Text, Separator, Box } from "@kiwicom/orbit-components";

// Assets
import LogoEinfach from "../../assets/images/footer-einfach.png";
import LogoRepnik from "../../assets/images/footer-repnik.png";
import LogoNaturakost from "../../assets/images/footer-naturkost.png";
// Utils
// import translate from "../../utils/translate";
// Components
import { Container } from "../Content/styles";

// Styles
import { Wrapper, LogoWrapper, Logo, LogoLink, LogoText } from "./Styled";

const Footer = () => {
  return (
    <Wrapper>
      <Container>
        <LogoWrapper>
          <Stack direction="column" align="center" justify="center">
            <LogoLink
              href="https://strawbox.eu"
              target="_blank"
              rel="noreferrer"
            >
              <Stack direction="column" align="center" justify="center">
                <Box className="">
                  <LogoText>
                    Schaut in unseren NATURKOST SHOP für PFERDE vorbei und
                    entdecke die Kraft von HANF ⬇️
                  </LogoText>
                </Box>
                <Logo src={LogoNaturakost} alt="Naturakost" />
              </Stack>
            </LogoLink>
            <Stack
              direction="row"
              spacing="XXLarge"
              justify="center"
              align="center"
              wrap
            >
              <LogoLink href="/">
                <Logo src={LogoEinfach} alt="Einfach" />
              </LogoLink>
              <LogoLink href="/">
                <Logo src={LogoRepnik} alt="Repnik" />
              </LogoLink>
            </Stack>
          </Stack>
        </LogoWrapper>
        <Separator spaceAfter="small" />
        <Stack justify="between" wrap>
          <Text type="white">
            © {new Date().getFullYear()} Hof der Lipizzaner
          </Text>
          <Text type="white">BIŠ 40, 2254 TRNOVSKA VAS, SLOWENIEN</Text>
        </Stack>
      </Container>
    </Wrapper>
  );
};

export default Footer;
